import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var MapDrawOutlineSVG = function MapDrawOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.8 5.11L26.89 2.2a.67.67 0 00-.48-.2.7.7 0 00-.49.2l-6.73 6.74L19 9l-8.86-2.95a.54.54 0 00-.28 0L3.45 7.59A2 2 0 002 9.51v16.84a2 2 0 002 2 2.15 2.15 0 00.55-.08L9.86 27a.61.61 0 01.27 0l8.7 2.9a.47.47 0 00.33 0l6.63-2.42a2 2 0 001.21-1.8V8.89l2.8-2.81a.68.68 0 000-.97zM9 25.22l-5 1.13V9.51l5-1.26zm9 2.45l-7-2.34V8.38l6.36 2.38-3.72 3.73a.42.42 0 00-.14.28l-.5 3.45a.69.69 0 00.19.58.67.67 0 00.48.2l3.55-.5a.42.42 0 00.28-.14l.49-.49zm-1.55-11.08l-1.22.18.18-1.22L20.93 10l2.9-2.9 1 1-3.28 3.28zM25 25.68l-5 1.93V15.88l2-2 3-3zm1.22-18.86l-1-1 1.3-1.3 1 1z"
  }));
};
MapDrawOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MapDrawOutlineSVG);